import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormFileUploadField } from './form-file-upload.model';
import { UtilService } from 'src/app/core/services/util.service';
import { FileHelper } from 'src/app/core/helpers/file.helpers';
import { FormFile } from '../../services/form.service';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-file-upload',
  templateUrl: './form-file-upload.component.html',
  styleUrls: ['./form-file-upload.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormFileUploadComponent extends FormBaseComponent<FormFileUploadField> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }


  @ViewChild('input_file', { static: true })
  inputFile: ElementRef<HTMLInputElement>;

  public files: FormFile[] = [];

  isButtonVisible = true;

  public fileHelper = FileHelper;

  public iconClass: string;

  constructor(
    private cd: ChangeDetectorRef,
    public _service: FormFieldService,
    private util: UtilService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    if (this.field.template.icon) {
      this.iconClass = `fa fa-${this.field.template.icon}`;
      this.callCD();
    }

    this.field.addFile = () => {
      this.selectFile();
    };
  }
  onComponentDestroy() { }

  selectFile() {
    this.inputFile.nativeElement.click();
  }

  fileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {

      const file = {
        file: input.files[0],
        data: null
      };

      const maxInBytes = this.field.maxFileSizeMB * (1024 * 1000);
      const isOversized = file.file.size > maxInBytes;

      if (isOversized) {
        this.util.dialog.inform(`Este arquivo é muito grande e não pode ser enviado.
          Por favor, envie um arquivo com no máximo ${FileHelper.humanFileSize(maxInBytes)}`, 'Atenção');
        return;
      }
      const reader = new FileReader();

      reader.onload = (e) => {
        file.data = e.target.result;


        if (this.service.params.afterAddFile) {
          this.service.params.afterAddFile(file, this.field);
        }

        if (this.field.valueChanges) {
          const updated = this.field.valueChanges(this.field, file, this.service);
          if (updated) {
            this.service.detectChanges$.next();
          }
        }
        this.files = [...this.files, file];
        this.callCD();
        setTimeout(() => {
          this.updateServiceFiles();
          this.updateButtonVisibility();
          this.callCD();

        }, 10);
      };

      reader.readAsDataURL(file.file);
      this.updateButtonVisibility();

    }
  }

  updateServiceFiles() {
    this.service.files[this.field.name] = this.files;
  }

  removeFile(file: FormFile) {
    const idx = this.files.indexOf(file);
    if (idx > -1) {
      this.files.splice(idx, 1);
      this.updateServiceFiles();
      this.updateButtonVisibility();
      this.callCD();
    }
  }

  preview(file: FormFile) {

  }

  private updateButtonVisibility() {
    this.isButtonVisible = false;

    if (this.field.multiple || this.field.maxFiles > 1) {
      if (this.field.maxFiles > 1) {
        if (this.files.length < this.field.maxFiles) {
          this.isButtonVisible = true;
        }
      } else  {
        this.isButtonVisible = true;
      }
    }

    if (this.files.length == 0) {
      this.isButtonVisible = true;
    }

    setTimeout(() => {
      this.service.detectChanges$.next();
    }, 150);
  }

  callCD() {
    setTimeout(() => {
      this.cd.detectChanges();
      this.service.detectChanges$.next();
    }, 10);
  }

}

